<template>
    <accordion-item :keep-closed="true" :content-pull="true">
        <h2 slot="header">
            Past Cost of Care
        </h2>

        <div class="m-div-table__holder">
            <benefit :estate-type="estateType"
                     title="Past Cost of Care"
                     subtitle="Attendance Allowance"
                     store-key="pcocAttendanceAllowance"
                     show-Header
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Cost of Care"
                     subtitle="Disability Living Allowance (care component)"
                     store-key="pcocDisabilityLivingAllowance"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Cost of Care"
                     subtitle="Industrial Injuries Disablement Benefit increase for Constant Attendance Allowance or Exceptionally Severe Disablement Allowance"
                     store-key="pcocIndustrialInjuriesDisablementBenefit"
            ></benefit>
            <benefit :estate-type="estateType"
                     title="Past Cost of Care"
                     subtitle="Personal Independence Payment (living component)"
                     store-key="pcocPersonalIndependencePayment"
                     is-last
            ></benefit>
        </div>
    </accordion-item>
</template>
<script>

    import AccordionItem from 'components/accordion/AccordionItem';
    import Benefit from "./Benefit";

    export default {
        components: {
            Benefit,
            AccordionItem,
        },
        props: {
            estateType: {
                type: String,
                required: true
            }
        },
    }
</script>


// WEBPACK FOOTER //
// PastCostOfCare.vue?79df7a4d